<template>
  <aside class="app-sidebar" :class="{ collapsed: sidebarCollapsed }">
    <el-menu
      :default-active="activeMenu"
      :collapse="sidebarCollapsed"
      background-color="#f5f7fa"
      text-color="#606266"
      active-text-color="#ffffff"
      router
    >
      <el-menu-item
        v-for="item in menus"
        :key="item.path"
        :index="item.path"
      >
        <i :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </el-menu>
  </aside>
</template>

<script>
import { mapState } from 'vuex'
import { sidebarMenus } from '@/config/menus'

export default {
  name: 'AppSidebar',
  computed: {
    ...mapState('app', ['currentModule', 'sidebarCollapsed']),
    menus() {
      return sidebarMenus[this.currentModule] || []
    },
    activeMenu() {
      return this.$route.path
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.app-sidebar {
  width: @sidebar-width;
  flex-shrink: 0;
  background: @sidebar-bg;
  border-right: 1px solid @border-color;
  overflow-y: auto;

  &.collapsed {
    width: 64px;
  }

  /deep/ .el-menu {
    border-right: none;

    .el-menu-item {
      height: 44px;
      line-height: 44px;

      &.is-active {
        background: @active-color !important;
        color: #fff !important;
      }

      i {
        color: inherit;
      }
    }
  }
}
</style>
